let resolvePromise;
const messagingBootPromise = new Promise(resolve => resolvePromise = resolve);
export function resolveMessagingBootPromise() {
    resolvePromise(null);
}
export function getMessagingBootPromise() {
    return messagingBootPromise;
}
